/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Coding_DescriptionInputs */

const en_directory_taxonomy_use_cases_coding_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Coding_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover coding assistants, developer tools, and technical workflows.`)
};

const zh_directory_taxonomy_use_cases_coding_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Coding_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现编程助手、开发者工具和技术工作流。`)
};

/**
* | output |
* | --- |
* | "Discover coding assistants, developer tools, and technical workflows." |
*
* @param {Directory_Taxonomy_Use_Cases_Coding_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_coding_description = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Coding_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Coding_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_coding_description(inputs)
	return zh_directory_taxonomy_use_cases_coding_description(inputs)
});
export { directory_taxonomy_use_cases_coding_description as "directory.taxonomy.use-cases.coding.description" }